export const loadKpiList = (locationId) => {
    return {
        type: 'METRICS_LIST_REQUEST',
        locationId
    };
};
export const coreNetworkDropDownList = (nodes = [], ecpdId, nibId) => {
    return {
        type: 'CORE_NETWORK_DROP_DOWN_LIST',
        nodes,
        ecpdId,
        nibId
    };
};

export const kpiNodesSuccess = (response) => {
    return {
        type: 'KPI_LOAD_SUCCESS',
        response
    };
};

export const kpiCoreNetworkGraphRequest = (type, payload) => {
    return {
        type,
        headers: payload
    };
};

export const kpiCoreNetworkGraphSuccess = (response = [[]], isEpg = false, isSA5GAMFCoreNodeRequest = false) => {
    return {
        type: 'KPI_CORE_NETWORK_GRAPH_DATA_SUCCESS',
        response,
        isEpg,
        isSA5GAMFCoreNodeRequest
    };
};

export const setInventoryData = (response) => {
    return {
        type: 'SET_INVENTORY_DATA',
        inventory: response
    };
};
